import { type FC } from 'react';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';

interface Props {
	data: string[][];
	fileName?: string;
}

const ExportCSV: FC<Props> = (props) => {
	const { data, fileName = 'chart_data.csv' } = props;

	const exportToCSV = (arrayData, fileName) => {
		const workSheet = XLSX.utils.aoa_to_sheet(arrayData);
		const workBook = { Sheets: { data: workSheet }, SheetNames: ['data'] };

		XLSX.writeFile(workBook, fileName, { bookType: 'csv' });
	};

	return (
		<Button size="sm" variant="warning" onClick={() => exportToCSV(data, fileName)}>
			Export CSV
		</Button>
	);
};

export default ExportCSV;
